module.exports = __webpack_public_path__ + "img/ACABADO.fc56d649.png";